module.exports = __webpack_public_path__ + "img/marker_four_blue3.b4421f54.png";